import './FileUploadModal.scss';

export { default } from './FileUploadModal';
